import React from 'react'
import Typography from '@mui/material/Typography'

const OpeningHours: React.FC = () => {
  return (
    <>
      <Typography variant="titleSmall" component="h4" mb={1}>
        Opening Hours:
      </Typography>
      <Typography variant="body1" component="p" mb={4} p={0}>
        Monday to Thursday 9am - 8pm
        <br />
        Friday 9am - 7pm
        <br />
        Saturday 9am - 6pm
        <br />
        Sunday 10am - 6pm
      </Typography>

      {/* Seasonal opening hours can be added here when needed. */}
      {/* <Typography variant="titleSmall" component="h4" mb={1}>
        Seasonal Opening Hours:
      </Typography>
      <Typography variant="body1" component="p" mb={4} p={0}>
        &#x26bd; Wednesday 15th July 2026 9am - 7pm &#x26bd;
      </Typography> */}
    </>
  )
}

export default OpeningHours
